'use client';
import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function LoginPage() {
  const router = useRouter();
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && localStorage.getItem('ff_token')) {
      router.replace('/dashboard');
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const endpoint = mode === 'login' ? '/api/auth/login' : '/api/auth/register';
      const body: any = { email, password };
      if (mode === 'register') body.company_name = companyName || 'Moje podjetje';

      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.detail || 'Napaka pri prijavi');
        return;
      }
      localStorage.setItem('ff_token', data.access_token);
      localStorage.setItem('ff_email', data.email);
      router.replace('/dashboard');
    } catch (err: any) {
      setError('Napaka pri povezavi s strežnikom');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="container animate-fade-in" style={{ maxWidth: '420px', marginTop: '6rem' }}>
      <div className="glass-card">
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>🔍</div>
          <h2 style={{ margin: 0 }}>FotoForenzika</h2>
          <p style={{ color: '#9ca3af', marginTop: '0.25rem', fontSize: '0.9rem' }}>
            {mode === 'login' ? 'Prijavite se v vaš račun' : 'Ustvarite nov račun'}
          </p>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {mode === 'register' && (
            <div>
              <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.85rem', color: '#9ca3af' }}>
                Ime podjetja / organizacije
              </label>
              <input
                type="text"
                value={companyName}
                onChange={e => setCompanyName(e.target.value)}
                placeholder="Npr. Moje podjetje d.o.o."
                style={{
                  width: '100%', padding: '0.65rem 0.9rem', borderRadius: '8px',
                  border: '1px solid #374151', background: '#111827',
                  color: '#f3f4f6', fontSize: '0.9rem', boxSizing: 'border-box',
                }}
              />
            </div>
          )}

          <div>
            <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.85rem', color: '#9ca3af' }}>
              E-naslov
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="vas@email.si"
              required
              style={{
                width: '100%', padding: '0.65rem 0.9rem', borderRadius: '8px',
                border: '1px solid #374151', background: '#111827',
                color: '#f3f4f6', fontSize: '0.9rem', boxSizing: 'border-box',
              }}
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.85rem', color: '#9ca3af' }}>
              Geslo
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={{
                width: '100%', padding: '0.65rem 0.9rem', borderRadius: '8px',
                border: '1px solid #374151', background: '#111827',
                color: '#f3f4f6', fontSize: '0.9rem', boxSizing: 'border-box',
              }}
            />
          </div>

          {error && (
            <div style={{
              padding: '0.65rem 0.9rem', borderRadius: '8px',
              background: 'rgba(248,113,113,0.1)', border: '1px solid rgba(248,113,113,0.3)',
              color: '#f87171', fontSize: '0.85rem',
            }}>
              ⚠️ {error}
            </div>
          )}

          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
            style={{ marginTop: '0.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.5rem' }}
          >
            {loading ? <div className="spinner" style={{ width: '16px', height: '16px', borderWidth: '2px' }}></div> : null}
            {mode === 'login' ? 'Prijava' : 'Registracija'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.85rem', color: '#6b7280' }}>
          {mode === 'login' ? (
            <>
              Nimate računa?{' '}
              <button onClick={() => { setMode('register'); setError(''); }}
                style={{ background: 'none', border: 'none', color: '#6366f1', cursor: 'pointer', fontWeight: 600, padding: 0 }}>
                Registracija
              </button>
            </>
          ) : (
            <>
              Že imate račun?{' '}
              <button onClick={() => { setMode('login'); setError(''); }}
                style={{ background: 'none', border: 'none', color: '#6366f1', cursor: 'pointer', fontWeight: 600, padding: 0 }}>
                Prijava
              </button>
            </>
          )}
        </div>

      </div>
    </main>
  );
}
